// extracted by mini-css-extract-plugin
module.exports = {"rowSwiper":"styles_rowSwiper__3gGLv","swiper":"styles_swiper__2XURG"};